import { format } from 'date-fns'

export const dateObjectToString = (dateObject = new Date(), stringFormat = 'yyyy-MM-dd') => {
  return format(dateObject, stringFormat)
}

export const addHours = (dateObject = new Date(), hour) => {
  return dateObject.setHours(dateObject.getHours() + hour)
}
